/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNotification } from '@/containers'
// import { useClickOutsideComponent } from '@/utils/useClickOutsideComponent'
// import DrawChat from '../DrawChat'
// import { IconChat } from '../Icon/IconChat'
// import { IconChatClose } from '../Icon/IconChatClose'
// import { IconHotLine } from '../Icon/IconHotLine'
// import { IconMessenger } from '../Icon/IconMessenger'
import { IconPhoneHotline } from '../Icon/IconPhoneHotline'
// import { IconZalo } from '../Icon/IconZalo'

export function PopupChat() {
  const { systemConfig } = useNotification()
  // const { ref, isComponentVisible, setIsComponentVisible } =
  //   useClickOutsideComponent(false)
  const hotline = systemConfig?.companyHotline1?.trim()
  return (
    <>
      {/* Tạm ẩn block cha (bong bóng chat mở ngăn Zalo / Messenger / CSKH).
          Mục "Mua ngay" đã đưa ra ngoài thành nút nổi ở bên dưới. Block bị
          tách làm 3 đoạn comment vì đoạn subiz ở giữa vốn đã là comment. */}
      {/* <DrawChat
        refer={ref || null}
        open={isComponentVisible}
        onClose={() => setIsComponentVisible(false)}
      >
        <div className='flex absolute flex-col gap-y-3 right-1 text-sm pb-28 h-full justify-end'>
          <a
            href={systemConfig?.companyZalo}
            target='_blank'
            className='zalo flex items-center justify-end'
          >
            <span className='mr-1 font-bold text-white-400'>Zalo</span>
            <span className='bg-blue-400 p-2.5 rounded-full'>
              <IconZalo />
            </span>
          </a>
          <a
            href={systemConfig?.companyMessenger}
            target='_blank'
            className='messenger flex  items-center justify-end'
          >
            <span className='mr-1 font-bold text-white-400'>Messenger</span>
            <IconMessenger />
          </a> */}
      {/* <a
            href='#nogo'
            onClick={() => (window as any).subiz('expandWidget')}
            className='subiz flex items-center justify-end'
          >
            <span className='mr-1 font-bold text-white-400'>Chat ngay</span>
            <IconChat />
          </a> */}
      {/* {systemConfig?.companyHotline2?.trim() && (
            <a
              href={`tel:${systemConfig.companyHotline2.trim()}`}
              className='messenger flex items-center justify-end'
            >
              <p className='mr-1 font-bold text-white-400 flex flex-col text-right'>
                <span>{systemConfig.companyHotlineText2?.trim()}</span>
                <span className='font-bold text-white-400'>
                  {systemConfig.companyHotline2}
                </span>
              </p>
              <IconHotLine />
            </a>
          )}
        </div>
      </DrawChat>
      <div
        onClick={() => setIsComponentVisible(true)}
        className='block z-[999] fixed bottom-16 right-1'
      >
        {isComponentVisible ? <IconChatClose /> : <IconChat />}
      </div> */}
      {/* Style lấy từ nút hotline bản desktop (nk-desktop-web1, component
          NotificationBar): viên đỏ + icon điện thoại nền trắng rung, icon
          nhô ra khỏi viên 5px bên phải. bottom-20 (thay vì bottom-16) để icon
          52px không đè lên thanh đáy cao 68-70px. */}
      {hotline && (
        <a
          href={`tel:${hotline}`}
          className='messenger z-[999] fixed bottom-20 right-2 flex h-[2.8rem] min-w-[150px] items-center justify-end rounded-full bg-redPico pl-4 pr-[58px]'
        >
          <p className='flex flex-col text-right text-[14px] font-bold leading-[1.35] text-white-400'>
            <span>{systemConfig?.companyHotlineText1?.trim()}</span>
            <span className='font-bold text-white-400'>
              {systemConfig?.companyHotline1}
            </span>
          </p>
          <span className='absolute right-[-5px] top-1/2 -translate-y-1/2'>
            <IconPhoneHotline className='quick-alo-circle-img-anim block' />
          </span>
        </a>
      )}
    </>
  )
}

export default PopupChat
